<div id="print-section">
  <app-request-summary *ngIf="request" [request]="request"></app-request-summary>
  
  <form-renderer id="form" #fr [formMetadata]="formMetaData" [ehrServerUrl]="ehrServerUrl" [credentials]="credentials"
    [context]="context" [formEnvironment]="formEnvironment" [compositionId]="compositionId"
    (onFormRendered)="formRendered($event)">
  </form-renderer>
</div>